// Canonical CMP settings toggle: 58x34 pill, white knob, emerald when on,
// slate track when off. All Chamber Settings switches must share this style
// (screenshot-driven; do not reintroduce per-tab switch sizes).
export const switchSx = {
  width: 58,
  height: 34,
  padding: 0,
  "& .MuiSwitch-switchBase": {
    padding: "4px",
    color: "#FFFFFF",
    "&.Mui-checked": {
      color: "#FFFFFF",
      transform: "translateX(24px)",
      "& + .MuiSwitch-track": {
        backgroundColor: "#10B981",
        opacity: 1,
      },
    },
    "&.Mui-disabled": {
      color: "#FFFFFF",
    },
    "&.Mui-disabled + .MuiSwitch-track": {
      opacity: 0.55,
    },
    "&.Mui-disabled.Mui-checked + .MuiSwitch-track": {
      backgroundColor: "#10B981",
      opacity: 0.65,
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "none",
    height: 26,
    width: 26,
  },
  "& .MuiSwitch-track": {
    backgroundColor: "#CBD5E1",
    borderRadius: 17,
    opacity: 1,
  },
};

// Membership Model selector variant: identical geometry, but the OFF state is
// red per the Figma screenshots (inactive model cards show a red DISABLED toggle).
export const modelOffRedSwitchSx = {
  ...switchSx,
  "& .MuiSwitch-track": {
    backgroundColor: "#EF4444",
    borderRadius: 17,
    opacity: 1,
  },
};
